import { IAnnotationConfig, IAnnotation } from '@indices/def';

export const annotation:IAnnotation = {
  circle: {
    pricePoints: [
      // {
      //   color: 'red',
      //   date: {
      //     year: 2011,
      //     month: 12,
      //     day: 19,
      //   },
      // },
      // {
      //   color: 'red',
      //   date: {
      //     year: 2013,
      //     month: 1,
      //     day: 4,
      //   },
      // },
      // {
      //   color: 'red',
      //   date: {
      //     year: 2015,
      //     month: 6,
      //     day: 9,
      //   },
      // },
      // {
      //   color: 'red',
      //   date: {
      //     year: 2016,
      //     month: 8,
      //     day: 15,
      //   },
      // },
      // {
      //   color: 'red',
      //   date: {
      //     year: 2019,
      //     month: 1,
      //     day: 1,
      //   },
      // },
      // {
      //   color: 'red',
      //   date: {
      //     year: 2020,
      //     month: 4,
      //     day: 7,
      //   },
      // },
      // {
      //   color: 'red',
      //   date: {
      //     year: 2020,
      //     month: 6,
      //     day: 15,
      //   },
      // },
      // {
      //   color: 'red',
      //   date: {
      //     year: 2020,
      //     month: 11,
      //     day: 29,
      //   },
      // },
      // {
      //   color: 'red',
      //   date: {
      //     year: 2021,
      //     month: 8,
      //     day: 3,
      //   },
      // },
    ],
    IndicePoints: [
      {
        color: 'red',
        date: {
          year: 2011,
          month: 12,
          day: 19,
        },
      },
      {
        color: 'red',
        date: {
          year: 2013,
          month: 1,
          day: 4,
        },
      },
      {
        color: 'red',
        date: {
          year: 2015,
          month: 6,
          day: 9,
        },
      },
      {
        color: 'red',
        date: {
          year: 2016,
          month: 8,
          day: 15,
        },
      },
      {
        color: 'red',
        date: {
          year: 2019,
          month: 1,
          day: 1,
        },
      },
      {
        color: 'red',
        date: {
          year: 2020,
          month: 4,
          day: 7,
        },
      },
      {
        color: 'red',
        date: {
          year: 2020,
          month: 6,
          day: 15,
        },
      },
      {
        color: 'red',
        date: {
          year: 2020,
          month: 11,
          day: 29,
        },
      },
      {
        color: 'red',
        date: {
          year: 2021,
          month: 8,
          day: 3,
        },
      },
    ],
  },
};
